import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ProvidersService {

  constructor(private firestore: AngularFirestore) {}

  public getProvider(documentId: string) {
    return this.firestore.collection('providers').doc(documentId).snapshotChanges();
  }

  public getProviders() {
    return this.firestore.collection('providers').snapshotChanges();
  }

  public createProvider(provider){
    delete provider.id;
    return this.firestore.collection('providers').add({...provider})
  }

  public updateProvider(provider){
    const id = provider.id;
    delete provider.id;
    return this.firestore.doc('providers/'+id).update({...provider});
  }

  public deleteProvider(id){
    return this.firestore.collection('providers').doc(id).delete();
  }

}